<ul class="file-restrictions-section">
  <li class="restrictions-container horizontal border-right">
    <div class="upload-source">
      <app-upload-source-selector
        [fileSection]="fileSection"
        [namespace]="namespace">
      </app-upload-source-selector>
    </div>
    <div class="checkbox-wrapper">
      <form [formGroup]="fileConfig">
        <mat-checkbox
          class="checkbox"
          [matTooltip]="'Uncheck to make file section optional'"
          [matTooltipPosition]="'right'"
          [matTooltipShowDelay]="500"
          [checked]="!fileConfig.value.optional"
          (change)="onDocumentOptionalChange()"
        >
          Required
        </mat-checkbox>
      </form>
    </div>
    <div class="checkbox-wrapper">
      <form [formGroup]="fileConfig">
        <mat-checkbox
          class="checkbox"
          formControlName="multiple"
          [matTooltip]="'Check to allow multiple files'"
          [matTooltipPosition]="'right'"
          [matTooltipShowDelay]="500"
        >
          Allow Multiple
        </mat-checkbox>
      </form>
    </div>
    @if (!combinedOutput) {
      <div class="checkbox-wrapper">
        <form [formGroup]="fileConfig">
          <mat-checkbox
            class="checkbox"
            formControlName="saveBackToDataSource"
            [matTooltip]="'Check to save this section back to the data source when the envelope is completed'"
            [matTooltipPosition]="'right'"
            [matTooltipShowDelay]="500"
          >
            Save back to data source
          </mat-checkbox>
        </form>
      </div>
    }
  </li>
  <li>
    <app-attachment-restrictions
      [fileSection]="fileSection"
      [entityType]="entityType"
      [namespace]="namespace"
      [expandUp]="true">
    </app-attachment-restrictions>
  </li>
</ul>
<!--{{ config | json }}-->
